// extracted by mini-css-extract-plugin
var _1 = "styles-module__columns___RJN7R";
var _2 = "styles-module__mobileColumns___RMRAm";
var _3 = "styles-module__next___Pcq3Z";
var _4 = "styles-module__prev___zHa8z";
export { _1 as "columns", _2 as "mobileColumns", _3 as "next", _4 as "prev" }
